"use client";

import styles from "./index.module.scss";

import { useAccordionContext } from "./context";
import Icon from "@/components/ui/Icon";

import IconComponent from '@/helpers/functions/getIcon';

export default function ItemTitle({ children, className, id }) {
  const { setToggle } = useAccordionContext();

  return (
    <div
      className={`${styles.toggle} ${className} bg-card text-base py-4 px-6 lg:px-8 rounded-lg mb-3 flex items-center justify-between`}
      onClick={() => setToggle(id)}
    >
      <div className="flex gap-2 items-center">
          <IconComponent
            iconName={"question_answer"}
            className="text-white !text-[16px] opacity-80 cursor-pointer "
          />
        {children}
      </div>
      <div className={styles.chevron}>
        <Icon name="chevron" className={"w-2 text-white/80"} />
      </div>
    </div>
  );
}
